import {Component, OnInit} from '@angular/core';
import {ModalInterface} from "../../modal.interface";
import {Observable, Subject} from "rxjs";
import {AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {ModalState} from "../../modal-state.enum";
import {ProjectRestService} from "../../../../api/services/project.rest.service";
import {ModalStateEvent} from "../../modal-state-event";
import {RxFormBuilder, RxwebValidators} from "@rxweb/reactive-form-validators";
import {AbstractComponent} from "../../../../core/components/abstract-component";
import {ModalComponent} from "../../modal.component";
import {ProjectApiModel} from "../../../../api/models/project.api-model";
import {TranslateService} from "@ngx-translate/core";
import {MessageService} from "primeng/api";
import {PdfThumbnailService} from "../../../../core/services/pdf-thumbnail.service";
import {DocumentApiModel} from "../../../../api/models/document.api-model";
import {DocumentUploadService} from "../../../../core/services/document-upload.service";
import {ResponseErrorsHandlerService} from "../../../../core/services/response-errors-handler.service";
import {FileRestService} from "../../../../api/services/file.rest.service";
import {format} from "date-fns";

@Component({
  selector: 'app-add-documents',
  templateUrl: './add-documents.component.html',
  styleUrls: ['./add-documents.component.scss'],
  providers: [MessageService]
})
export class AddDocumentsComponent extends AbstractComponent implements OnInit, ModalInterface {
  public readonly maxDocumentFileSizeBytes = 50 * 1024 * 1024;

  get pendingDocuments(): UntypedFormArray {
    if (this.form && this.form.get('pendingDocuments')) {
      return this.form.get('pendingDocuments') as UntypedFormArray;
    }
  }

  get uploadedDocuments(): UntypedFormArray {
    if (this.form && this.form.get('uploadedDocuments')) {
      return this.form.get('uploadedDocuments') as UntypedFormArray;
    }
  }

  // get pendingDocuments(): AbstractControl[] {
  //   return this.pendingDocuments.controls.filter((control) => !control.value['@id']);
  // }
  //
  // get uploadedDocuments(): AbstractControl[] {
  //   return this.pendingDocuments.controls.filter((control) => control.value['@id']);
  // }

  public data: any;
  public parent?: ModalComponent;
  public subject: Subject<ModalStateEvent>;
  public state: Observable<ModalStateEvent>;
  public form: UntypedFormGroup;
  public project: ProjectApiModel;
  public documentsAMs: DocumentApiModel[] = [];
  public files = [];
  public totalSize : number = 0;
  public totalSizePercent : number = 0;
  public uploadProgress: number = 0;
  private fileKeys = new Set<string>();
  constructor(
    private readonly fb: RxFormBuilder,
    private readonly projectRS: ProjectRestService,
    private readonly messageService: MessageService,
    private readonly translate: TranslateService,
    private readonly pdfThumbnail: PdfThumbnailService,
    private readonly documentUploader: DocumentUploadService,
    private readonly responseErrorsHandler: ResponseErrorsHandlerService,
    private readonly fileRS: FileRestService,
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.project = this.data['project'].toApiModel();
    this.documentsAMs = this.data['documentAMs'];
    this.createForm();
    await this.updateThumbnails();
    this.patchForm();
    this.subscribeParentModalState();
  }


   createForm(): void {
    this.form = this.fb.group({
      pendingDocuments: [],
      uploadedDocuments: [],
    });
  }

  private emitValidState(): void {
      this.subject.next(new ModalStateEvent(ModalState.VALID));
  }

  private emitProcessEndState(): void {
    this.subject.next(new ModalStateEvent(ModalState.PROCESS_END));
  }

  private emitSuccessState(): void {
    this.subject.next(new ModalStateEvent(ModalState.SUCCESS));
  }

  private emitPendingState(): void {
    this.subject.next(new ModalStateEvent(ModalState.PENDING));
  }

  private subscribeParentModalState(): void {
    this.subscriptions.push(this.state.subscribe(modalState => {
      if (modalState.status === ModalState.PENDING) {
        this.submit()
      }
    }));
  }
  private submit(): void {
    if(!this.form.valid) {
      console.log('validation failed');
      return;
    }

    this.pendingDocuments.getRawValue().forEach((document: any) => {
      const documentAM = this.documentsAMs.find(e => this.getFileKey(document['file']) === this.getFileKey(e.file));
      documentAM.description = document.description;
      documentAM.file = document.file;
    });

    this.uploadedDocuments.getRawValue().forEach((document: any) => {
      const documentAM = this.documentsAMs.find(e => this.getFileKey(document['file']) === this.getFileKey(e.file));
      documentAM.description = document.description;
      documentAM.file = document.file;
    });

    this.subscriptions.push(
      this.documentUploader.uploadDocument(this.documentsAMs).subscribe(({documents$, progress$}) => {
        progress$.subscribe({
          next: (progress) => {
            this.uploadProgress = progress; // Aktualizacja procentowego postępu
          },
          error: (errorResponse) => {
            this.responseErrorsHandler.handleServerErrors(errorResponse);
            this.emitProcessEndState();
          }
        });

        documents$.subscribe({next: (uploadedDocuments: DocumentApiModel[]) => {
          const newMedia = uploadedDocuments.map((documentAM: DocumentApiModel) => documentAM['@id']);
          // const existingDocuments = this.documentsAMs.filter(m => m['@id']).map(m => m['@id']) as string[] || [];
          this.project.documents = newMedia;
          this.projectRS.put(this.project).subscribe({
            next: async () => {
              await Promise.all(uploadedDocuments.map(async document => {
                  if (!document.thumbnail) {
                    document.file = document.file || await this.fileRS.getFile(document.hyperlinks[0].uri).toPromise();
                    document.thumbnail = await this.pdfThumbnail.generateThumbnail(document.file
                  , 600);
                  }

                  return document;
              }));
              this.subject.next(new ModalStateEvent(ModalState.SUCCESS, uploadedDocuments));
            },
            error: (errorResponse) => {
              console.log(errorResponse);
              // this.isSubmitted = false;
              this.uploadProgress = null;
              this.responseErrorsHandler.handleFormErrors(this.form, errorResponse);
              this.emitProcessEndState();
            }
          });
        },
        error: (errorResponse) => {
          this.responseErrorsHandler.handleFormErrors(this.form, errorResponse);
          this.emitProcessEndState();
        }
        });
      }
      )
    );
    // this.subscriptions.push(this.projectRS.addDocument(this.project, this.form.value).subscribe(() => {
    //   this.emitSuccessState();
    // }));
  }

  choose(event, callback) {
    callback();
  }

  // onRemoveTemplatingFile(event, file, removeFileCallback, index) {
  //   removeFileCallback(event, index);
  //   this.totalSize -= parseInt(this.formatSize(file.size));
  //   this.totalSizePercent = this.totalSize / 10;
  //   this.documents.removeAt(index);
  // }

  // onRemoveTemplatingFile(event, file: File, removeFileCallback, index: number) {
  //   removeFileCallback(event, index);
  //   this.totalSize -= file.size;
  //   this.totalSizePercent = (this.totalSize / (1024 * 1024)) * 100;
  //
  //   // usuń z FormArray i z listy AM
  //   this.removeDocument(index);
  //
  //   // usuń fingerprint
  //   this.fileKeys.delete(this.getFileKey(file));
  // }

  onClearTemplatingUpload(clear) {
    clear();
    this.totalSize = 0;
    this.totalSizePercent = 0;
  }

  onTemplatedUpload() {
    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000 });
  }
  //
  // onSelectedFiles(event) {
  //   this.files = event.currentFiles;
  //   console.log(event);
  //   new Promise<void>((resolve) => {
  //     this.files.forEach(async (file) => {
  //       this.totalSize += parseInt(this.formatSize(file.size));
  //       if (file.type === 'application/pdf') {
  //         file.thumbnail = await this.pdfThumbnail.generateThumbnail(file, 600);
  //       }
  //
  //       console.log(this.documentsAMs.find(e => e.file === file));
  //       if (!this.documentsAMs.find(e => e.file === file)) {
  //         console.log('test');
  //         const documentAM = new DocumentApiModel();
  //         documentAM.file = file;
  //         this.documentsAMs.push(documentAM);
  //       }
  //     });
  //     this.totalSizePercent = this.totalSize / 10;
  //     resolve();
  //   }).then(() => this.patchForm());
  // }

  // async onSelectedFiles(event: any): Promise<void> {
  //   const selected: File[] = event?.currentFiles ?? event?.files ?? [];
  //   if (!this.documentsAMs) this.documentsAMs = [];
  //
  //   // tylko nowe (po kluczu), nawet jeśli obiekt File jest inny
  //   const newFiles = selected.filter(f => {
  //     const key = this.getFileKey(f);
  //     if (this.fileKeys.has(key)) return false;
  //     this.fileKeys.add(key);
  //     return true;
  //   });
  //
  //   let bytesAdded = 0;
  //
  //   await Promise.all(
  //     newFiles.map(async (file) => {
  //       const doc = new DocumentApiModel();
  //       doc.file = file;
  //
  //       if (file.type === 'application/pdf' || file.type.startsWith('application/pdf')) {
  //         try {
  //           (file as any).thumbnail = await this.pdfThumbnail.generateThumbnail(file, 600);
  //         } catch (e) {
  //           console.error('PDF thumbnail error', e);
  //         }
  //       }
  //
  //       this.documentsAMs.push(doc);
  //       bytesAdded += file.size;
  //     })
  //   );
  //
  //   this.totalSize += bytesAdded;
  //   this.totalSizePercent = (this.totalSize / (1024 * 1024)) * 100;
  //
  //   this.patchForm();
  // }

  uploadEvent(callback) {
    callback();
  }

  clearEvent(callback ) {
    this.pendingDocuments.clear();
    this.documentsAMs = this.documentsAMs.filter(e => e["@id"])
    callback();
  }

  formatSize(bytes) {
    const k = 1024;
    const dm = 3;
    const sizes = [
      'common.b',
      'common.B',
      'common.KB',
      'common.MB',
      'common.GB',
      'common.TB',
    ];
    if (bytes === 0) {
      return `0 ${this.translate.instant(sizes[0])}`;
    }

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${formattedSize} ${this.translate.instant(sizes[i])}`;
  }

  createDocumentsGroup(documentAM: DocumentApiModel = null): UntypedFormGroup {
    return this.fb.group({
      file: new UntypedFormControl(documentAM.file),
      description: new UntypedFormControl(documentAM?.description ? documentAM.description : '', [
        RxwebValidators.minLength({value: 2}),
        RxwebValidators.maxLength({value: 255}),
      ]),
      createdAt: new UntypedFormControl(documentAM.createdAt ? format(documentAM.createdAt, 'dd.MM.yyyy'): null),
      '@id': new UntypedFormControl(documentAM['@id'])
    });
  }

  addPendingDocument(documentAM: DocumentApiModel = null): void {
    const group = this.createDocumentsGroup(documentAM);
    this.pendingDocuments.push(group);
  }

  addUploadedDocument(documentAM: DocumentApiModel = null): void {
    const group = this.createDocumentsGroup(documentAM);
    this.uploadedDocuments.push(group);
  }

  removeDocument(index: number): void {
    this.pendingDocuments.removeAt(index);
  }

  private patchForm(): void {
    // Jeśli kontrolki documents jeszcze nie ma, to ją dodaj
    if (!this.pendingDocuments) {
      this.form.addControl('pendingDocuments', new UntypedFormArray([], [
        RxwebValidators.choice({minLength: 1})
      ]));
    }

    if (!this.uploadedDocuments) {
      this.form.addControl('uploadedDocuments', new UntypedFormArray([], [
        RxwebValidators.choice({minLength: 1})
      ]));
    }

    // Aktualna lista "kluczy" plików w formularzu
    const existingPendingKeys = this.pendingDocuments.controls.map(ctrl =>
      this.getFileKey((ctrl.value as DocumentApiModel).file)
    );

    // Dodaj tylko te dokumenty, których jeszcze nie ma w formularzu
    this.documentsAMs.filter(e => !e['@id']).forEach((documentAM: DocumentApiModel) => {
      const fileKey = this.getFileKey(documentAM.file);
      if (!existingPendingKeys.includes(fileKey)) {
        this.addPendingDocument(documentAM);
        existingPendingKeys.push(fileKey); // aktualizujemy, żeby uniknąć podwójnego dodania w tej samej pętli
      }
    });

    const existingUploadedKeys = this.uploadedDocuments.controls.map(ctrl =>
      this.getFileKey((ctrl.value as DocumentApiModel).file)
    );

    this.documentsAMs.filter(e => e['@id']).forEach((documentAM: DocumentApiModel) => {
      const fileKey = this.getFileKey(documentAM.file);
      if (!existingUploadedKeys.includes(fileKey)) {
        this.addUploadedDocument(documentAM);
        existingUploadedKeys.push(fileKey); // aktualizujemy, żeby uniknąć podwójnego dodania w tej samej pętli
      }
    });
  }
  private getFileKey(file: File): string {
    // lastModified może być 0 w niektórych środowiskach – i tak jest ok
    return `${file.name}|${file.size}|${file.type}|${file.lastModified}`;
  }

  // private getFileKey = (f: File) =>
  //   `${f.name}|${f.size}|${f.type}|${f.lastModified}`;

  async onSelectedFiles(event: any) {
    console.log('selectedFiles');
    const selected: File[] = event?.currentFiles ?? [];
    const newFiles = selected.filter(f =>
      !this.documentsAMs.some(d => this.getFileKey(d.file) === this.getFileKey(f))
    );
    console.log(this.documentsAMs, newFiles);

    await Promise.all(newFiles.map(async file => {
      const doc = new DocumentApiModel();
      doc.file = file;
      if (file.type === 'application/pdf') {
        (file as any).thumbnail = await this.pdfThumbnail.generateThumbnail(file, 600);
      }
      this.documentsAMs.unshift(doc);
      this.totalSize += file.size;
    }));

    this.totalSizePercent = this.totalSize / 10;
    this.patchForm();
  }

  async updateThumbnails(): Promise<void> {
    await Promise.all(this.documentsAMs.map(async doc => {
      const file = doc.file;
      if (file.type === 'application/pdf') {
        (file as any).thumbnail = await this.pdfThumbnail.generateThumbnail(file, 600);
      }
      this.totalSize += file.size;
      return doc;
    }));
  }

  onRemoveTemplatingFile(event: Event, document: AbstractControl, removeFileCallback: (...args: unknown[]) => unknown, index?: number) {
    event.stopPropagation();
    const file = document.get('file').value;
    const documentId = document.get('@id').value;
    if (documentId !== null) {
      this.subscriptions.push(this.documentUploader.deleteDocumentForProject(documentId, this.project)
        .subscribe(() => {
          this.uploadedDocuments.removeAt(index);
        }));
    } else {
      this.pendingDocuments.removeAt(index);
    }
    const keyToRemove = this.getFileKey(file);

    // Usuń z modelu
    this.documentsAMs = this.documentsAMs.filter(
      d => this.getFileKey(d.file) !== keyToRemove
    );

    // Usuń z UI
    // removeFileCallback(file, index);

    this.totalSize = this.documentsAMs.reduce((sum, d) => sum + d.file.size, 0);
    this.totalSizePercent = this.totalSize / 10;

      this.removeDocument(index);
  }
}
